import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  IStudentListItemDTO,
  IStudentListSortDTO,
} from '@app/infrastructure/models/student';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-grading-period-router',
  templateUrl: './grading-period-router-component.component.html',
  styleUrls: ['./grading-period-router-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradingPeriodRouterComponent {
  public studentList: string;
  viewUnits(value: IStudentListSortDTO) {
    this.studentList = value.gradingPeriodId;
  }
}
